/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import template from './layout-list-page.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../../common/controller/admin-resource-list-page-base';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {LocalUserProfile} from '../../../components/session/local-user-profile';

@Component({
  standalone: false,
  selector: 'adn-layout-list-page',
  template
})
export class LayoutListPageComponent extends AdminResourceListPageBase implements OnInit {
  readonly itemStateName = 'app.adm.layouts.layout';

  showApprovalStatus = false;
  columns: AdminListColumn[] = [
    {param: 'name'},
    {param: 'layoutType', label: 'type'},
    {param: '', label: 'components', sortable: false},
    {param: 'layoutCategory', label: 'layoutCategory'}
  ];

  constructor(
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    @Inject(LocalUserProfile) private localUserProfile: any
  ) {
    super(LocalNetworkProfile);
  }

  ngOnInit(): void {
    super.ngOnInit();
    const isSpecialUser = this.localUserProfile.get('username') === 'adnuntius@adnuntius.com' || this.localUserProfile.get('username') === 'broker1@adnuntius.com';
    this.showApprovalStatus = this.LocalNetworkProfile.isPureMarketplacePlatform() && isSpecialUser;
    if (this.showApprovalStatus) {
      this.columns = [...this.columns, {param: '', label: 'approvalStatus', sortable: false}];
    }
  }
}
